import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faFilePdf } from '@fortawesome/pro-regular-svg-icons';
import { PlainModal } from '@client/new/components/Modal/Modal';
import { Typography } from '@design-system/components/typography/typography';
import { UploadItem } from '../components/UploadItem';
import { ContentPDF } from '../model/extras.domain';
import { DropZone } from '@design-system/components/dropZone/dropZone';
import { Row } from '@design-system/components/grid/grid';
import SuperTooltip from '@client/new/components/SuperTooltip/SuperTooltip';

type PDFModalProps = {
  onChange: (file: File) => void;
  isOpen: boolean;
  onClose: () => void;
  content: ContentPDF['value'];
  progress: number;
};

export const PDFModal = (p: PDFModalProps) => (
  <PlainModal
    isOpen={p.isOpen}
    onClose={p.onClose}
    title="Upload PDF file"
    height="auto"
    sx={{
      display: 'flex',
      flexDirection: 'column',
      gap: '24px',
      padding: '0px',
      maxWidth: '740px',
      minHeight: '320px',
    }}
  >
    <div
      data-testid="pdf-upload-modal"
      style={{
        padding: 24,
        display: 'flex',
        gap: 24,
        flexDirection: 'column',
      }}
    >
      <div className="flex justify-between">
        <Row alignCenter>
          <Typography variant="headline">Upload PDF file</Typography>
          <SuperTooltip templateId="extras-pdf" />
        </Row>
        <div className="cursor-pointer" onClick={p.onClose} role="button">
          <FontAwesomeIcon
            icon={faTimes}
            className="ml-3 leading-none text-sm w-[28px] h-[28px] self-center"
          />
        </div>
      </div>
      <Typography>Maximum size 30MB</Typography>
      <div style={{ gap: 5, flexDirection: 'column', display: 'flex' }}>
        {p.progress ? (
          <UploadItem
            name={p.content.fileName}
            error={false}
            // onCancel={console.log}
            progressValue={p.progress}
            icon={faFilePdf}
          />
        ) : (
          <DropZone
            className="h-[170px] text-center"
            accept={['application/pdf']}
            onChange={(f: File[]) => p.onChange(f[0])}
          />
        )}
      </div>
    </div>
  </PlainModal>
);
